import React, { useState } from "react";
import { Button, Flex } from "components";
import { ELEMENTS_IDS } from "constants/ElementsIds";
import { AddSelectedAnimalsToGroup } from "components/MyLivestock";
import { LogActivityModal } from "animals/LogActivityModal";
import { MarkAsDeadModal } from "animals/MarkAsDeadModal";
import { AddSelectedAnimalsToTag } from "components/MyLivestock/Animals/AnimalBulkActions/AddSelectedAnimalsToTag";
import { RemoveSelectedAnimalsToTag } from "components/MyLivestock/Animals/AnimalBulkActions/RemoveSelectedAnimalsToTag";
import { MoveToFieldModal } from "fields/MoveToFieldModal";
import { useHasFeature } from "hooks";
import { TABLE_IDS } from "constants/Interface";
import { MarkOffFarmModal } from "components/MyLivestock/Animals/AnimalBulkActions/MarkOffFarm/MarkOffFarmModal";
import { ConfirmAddPreviousKeeperModal } from "components/MyLivestock/Animals/AnimalBulkActions/ConfirmAddPreviousKeeperModal";

interface Props {
  animalIds: Array<string>;
}

export const AnimalActions: React.FC<Props> = ({ animalIds = [] }) => {
  const [showMoveToFieldModal, setShowMovetoFieldModal] = useState(false);
  const [showMarkAsDeadModal, setShowMarkAsDeadModal] = useState(false);

  const handleMoveAnimalToFieldClick = (): void => setShowMovetoFieldModal(true);
  const handleMoveAnimalToFieldClose = (): void => setShowMovetoFieldModal(false);

  const isMovementsEnabled = useHasFeature("OUTWARD_MOVEMENTS");

  return (
    <Flex container containerJustifyContent="flex-end" xs="fill">
      <Flex item itemGutter>
        <AddSelectedAnimalsToGroup animalIds={animalIds} />
      </Flex>

      <Flex item itemGutter>
        <Button
          caption="Move to location"
          id={ELEMENTS_IDS.ANIMALS_MOVE_TO_FIELD_BUTTON}
          onClick={handleMoveAnimalToFieldClick}
        />

        <MoveToFieldModal
          animalIds={animalIds}
          onClose={handleMoveAnimalToFieldClose}
          showModal={showMoveToFieldModal}
        />
      </Flex>
      <Flex item>
        <ConfirmAddPreviousKeeperModal animalIds={animalIds} />
      </Flex>

      <Flex item itemGutter>
        <AddSelectedAnimalsToTag animalIds={animalIds} />
      </Flex>
      <Flex item>
        <RemoveSelectedAnimalsToTag animalIds={animalIds} />
      </Flex>

      {isMovementsEnabled ? null : (
        <>
          <div style={{ width: 10 }} />
          <Flex item>
            <MarkOffFarmModal animalIds={animalIds} tableId={TABLE_IDS.ANIMALS} />
          </Flex>
        </>
      )}

      <Flex item itemGutter>
        <Button caption="Mark as dead" onClick={() => setShowMarkAsDeadModal(true)} />
        {showMarkAsDeadModal ? (
          <MarkAsDeadModal
            onClose={() => setShowMarkAsDeadModal(false)}
            animalIds={animalIds}
            showModal={showMarkAsDeadModal}
          />
        ) : null}
      </Flex>

      <Flex item>
        <LogActivityModal animalIds={animalIds} />
      </Flex>
    </Flex>
  );
};
